import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XCircle, CheckCircle2, ChevronDown, Shield, Star, FileText, Zap, BookOpen, Download, Lock, CreditCard } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-navy selection:bg-electric selection:text-white" data-id="element-23">
      <main data-id="element-24">
        {/* SECCIÓN 1 — HERO ABOVE THE FOLD */}
        <section className="bg-[#FDFBF7] text-gray-900 px-4 relative overflow-hidden md:pt-12 md:pb-16" data-id="element-25">
          {/* ABOVE-THE-FOLD CONTAINER — fits in one iPhone viewport */}
          <div className="min-h-[100svh] md:min-h-0 flex flex-col justify-center py-6 md:py-0 max-w-5xl mx-auto text-center relative z-10 w-full" data-id="element-26">
            {/* Logo / Brand */}
            <div className="flex justify-center mb-5 md:mb-8" data-id="element-27">
              <span className="text-xl md:text-2xl font-black tracking-tight text-gray-900" data-id="element-28">
                <span className="text-[#E84C3D]" data-id="element-29">EF</span>360
              </span>
            </div>

            <h1 className="font-serif text-[34px] leading-[1.05] md:text-6xl lg:text-7xl font-black md:leading-[1.05] mb-4 md:mb-6 tracking-tight px-1 md:px-0 text-gray-900 max-w-5xl mx-auto" data-id="element-30">
              Resuelve un año entero de clases de Educación Física en solo{' '}
              <span className="text-[#E84C3D] italic font-serif" data-id="element-31">
                5 minutos
              </span>
            </h1>

            <p className="text-gray-600 text-[15px] md:text-xl font-medium max-w-3xl mx-auto mb-6 md:mb-10 leading-snug md:leading-relaxed px-4 md:px-0" data-id="element-32">
              Más de 2.000 profesores ya dejaron de improvisar. Llega al patio
              con todo listo para enseñar, motivar y poner en movimiento a tus
              alumnos.
            </p>

            <div className="flex justify-center mb-6 md:mb-10" data-id="element-33">
              <img src="https://cdn.magicpatterns.com/uploads/8QuB2wJqs2ZConF9yjKtuA/MOCK_ED_F_NUEVO.png" alt="Pack Completo Educación Física 360 — 12 Tomos + 6 Bonos" width="1200" height="1500" loading="eager" decoding="async" fetchPriority="high" className="w-auto max-h-[35vh] md:max-h-none md:w-full md:max-w-2xl lg:max-w-3xl object-contain drop-shadow-xl" data-id="element-34" />
            </div>

            <div className="flex flex-col items-center justify-center" data-id="element-35">
              <a href="#precio" className="inline-flex items-center justify-center bg-[#E84C3D] hover:bg-[#d64536] text-white font-bold text-lg md:text-2xl py-4 md:py-5 px-8 md:px-16 rounded-full transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 w-[90%] md:w-auto" data-id="element-36">
                QUIERO MI EF360 AHORA
              </a>

              <div className="flex flex-wrap justify-center gap-x-2 gap-y-1 md:gap-3 mt-4 md:mt-6 text-[11px] md:text-sm text-gray-500 font-medium" data-id="element-37">
                <span data-id="element-38">Descarga inmediata</span>
                <span className="hidden md:inline" data-id="element-39">·</span>
                <span className="md:hidden" data-id="element-40">|</span>
                <span data-id="element-41">Sin suscripción</span>
                <span className="hidden md:inline" data-id="element-42">·</span>
                <span className="md:hidden" data-id="element-43">|</span>
                <span data-id="element-44">Acceso de por vida</span>
                <span className="hidden md:inline" data-id="element-45">·</span>
                <span className="md:hidden" data-id="element-46">|</span>
                <span data-id="element-47">Garantía 7 días</span>
              </div>

              {/* 5-star social proof — kept in the hero, below the CTA */}
              <div className="flex items-center justify-center gap-1.5 md:gap-2 mt-4 md:mt-5 text-[11px] md:text-sm" data-id="element-48">
                <div className="flex gap-0.5" data-id="element-49">
                  {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-[#E84C3D] text-[#E84C3D] md:w-[18px] md:h-[18px]" data-id="element-50" />)}
                </div>
                <span className="font-bold text-gray-900" data-id="element-51">4.9/5</span>
                <span className="text-gray-500" data-id="element-52">· +2.000 profes confían</span>
              </div>
            </div>
          </div>
        </section>

        {/* NEW STATS BAR */}
        <section className="bg-white border-b border-gray-200 py-8 md:py-12 px-4" data-id="element-53">
          <div className="max-w-5xl mx-auto" data-id="element-54">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8 divide-x-0 md:divide-x divide-gray-200" data-id="element-55">
              <div className="flex flex-col items-center justify-center px-4" data-id="element-56">
                <span className="font-serif text-4xl md:text-5xl font-black text-gray-900 mb-2" data-id="element-57">
                  +480
                </span>
                <span className="text-xs text-gray-500 uppercase tracking-widest font-bold text-center" data-id="element-58">
                  SESIONES LISTAS
                </span>
              </div>
              <div className="flex flex-col items-center justify-center px-4" data-id="element-59">
                <span className="font-serif text-4xl md:text-5xl font-black text-gray-900 mb-2" data-id="element-60">
                  +2.000
                </span>
                <span className="text-xs text-gray-500 uppercase tracking-widest font-bold text-center" data-id="element-61">
                  DOCENTES SATISFECHOS
                </span>
              </div>
              <div className="flex flex-col items-center justify-center px-4" data-id="element-62">
                <span className="font-serif text-4xl md:text-5xl font-black text-gray-900 mb-2" data-id="element-63">
                  3.500+
                </span>
                <span className="text-xs text-gray-500 uppercase tracking-widest font-bold text-center" data-id="element-64">
                  HORAS AHORRADAS
                </span>
              </div>
              <div className="flex flex-col items-center justify-center px-4" data-id="element-65">
                <span className="font-serif text-4xl md:text-5xl font-black text-gray-900 mb-2 flex items-center gap-1" data-id="element-66">
                  99%
                </span>
                <span className="text-xs text-gray-500 uppercase tracking-widest font-bold text-center" data-id="element-67">
                  LO RECOMIENDAN
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* TRANSFORMATION & COMPARISON & 3 STAT CARDS */}
        <section className="bg-[#FDFBF7] py-16 md:py-24 px-4" data-id="element-68">
          <div className="max-w-6xl mx-auto" data-id="element-69">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center mb-16 md:mb-24" data-id="element-70">
              {/* LEFT: Headline & 3500+ Card */}
              <div className="max-w-xl mx-auto lg:mx-0 text-center lg:text-left" data-id="element-71">
                <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-[1.1] mb-8" data-id="element-72">
                  De un docente sobrecargado a un{' '}
                  <span className="text-[#E84C3D] italic font-serif" data-id="element-73">
                    guía deportivo inspirado.
                  </span>
                </h2>
                <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-200 inline-flex flex-col md:flex-row items-center gap-4 md:gap-6 text-left" data-id="element-74">
                  <span className="font-serif text-5xl md:text-6xl font-black text-[#F59E0B]" data-id="element-75">
                    +3.500
                  </span>
                  <span className="text-gray-600 font-medium text-sm md:text-base leading-snug max-w-[180px]" data-id="element-76">
                    horas ahorradas al año en planificación.
                  </span>
                </div>
              </div>

              {/* RIGHT: Comparison Card */}
              <div className="bg-white rounded-3xl shadow-lg border border-gray-100 overflow-hidden flex flex-col sm:flex-row" data-id="element-77">
                {/* ANTES */}
                <div className="flex-1 p-6 md:p-8 border-b sm:border-b-0 sm:border-r border-gray-100" data-id="element-78">
                  <div className="flex items-center gap-2 text-[#F59E0B] font-bold mb-6 text-sm tracking-wide" data-id="element-79">
                    <div className="bg-[#FEF3C7] rounded-full p-0.5" data-id="element-80">
                      <XCircle size={14} data-id="element-81" />
                    </div>
                    ANTES
                  </div>
                  <ul className="space-y-4" data-id="element-82">
                    {['Domingo a la noche planificando desde cero', 'Actividades improvisadas sin progresión real', 'Grupos sin estructura ni continuidad', 'El alumno con certificado te genera un problema', 'Te piden ESI y EAI y no sabés qué poner', 'Terminar cada semana agotado/a y sin rumbo'].map((text, i) => <li key={i} className="flex items-start gap-3 text-gray-500 font-medium text-sm md:text-base" data-id="element-83">
                        <XCircle size={18} className="text-gray-300 shrink-0 mt-0.5" data-id="element-84" />
                        {text}
                      </li>)}
                  </ul>
                </div>
                {/* CON EF360 */}
                <div className="flex-1 p-6 md:p-8 bg-[#FFF5F5]" data-id="element-85">
                  <div className="flex items-center gap-2 text-[#E84C3D] font-bold mb-6 text-sm tracking-wide" data-id="element-86">
                    <div className="bg-[#FEE2E2] rounded-full p-0.5" data-id="element-87">
                      <CheckCircle2 size={14} data-id="element-88" />
                    </div>
                    CON EF360
                  </div>
                  <ul className="space-y-4" data-id="element-89">
                    {['5 minutos el domingo. Listo.', '+150 actividades graficadas por nivel', 'Un sistema claro para cada año escolar', '10 TPs listos para entregar y calificar', 'Texto listo para copiar en el PCI', 'Llegás a clase con todo resuelto'].map((text, i) => <li key={i} className="flex items-start gap-3 text-gray-900 font-bold text-sm md:text-base" data-id="element-90">
                        <CheckCircle2 size={18} className="text-[#E84C3D] shrink-0 mt-0.5" data-id="element-91" />
                        {text}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>

            {/* 3 STAT CARDS */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-92">
              <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 text-center flex flex-col items-center justify-center" data-id="element-93">
                <span className="font-serif text-4xl md:text-5xl font-black text-[#E84C3D] mb-2" data-id="element-94">
                  +480
                </span>
                <span className="text-gray-500 font-bold text-sm uppercase tracking-widest" data-id="element-95">
                  SESIONES
                </span>
              </div>
              <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 text-center flex flex-col items-center justify-center" data-id="element-96">
                <span className="font-serif text-4xl md:text-5xl font-black text-[#E84C3D] mb-2" data-id="element-97">
                  12
                </span>
                <span className="text-gray-500 font-bold text-sm uppercase tracking-widest" data-id="element-98">
                  TOMOS
                </span>
              </div>
              <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 text-center flex flex-col items-center justify-center" data-id="element-99">
                <span className="font-serif text-4xl md:text-5xl font-black text-[#E84C3D] mb-2" data-id="element-100">
                  100%
                </span>
                <span className="text-gray-500 font-bold text-sm uppercase tracking-widest" data-id="element-101">
                  DESCARGABLE
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS (Moved here to preserve them, adapted to light theme) */}
        <section className="bg-white py-16 px-4 border-b border-gray-100" data-id="element-102">
          <div className="max-w-5xl mx-auto" data-id="element-103">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left" data-id="element-104">
              {[{
              init: 'MP',
              quote: '"Organicé todo el mes en una tarde. Nunca más llego a clase sin saber qué actividad voy a dar."',
              name: 'María P., Buenos Aires',
              role: 'Profesora de EF en Escuela Primaria'
            }, {
              init: 'CG',
              quote: '"Mis alumnos de 1° primaria mejoraron su coordinación desde la primera semana con el Tomo 1."',
              name: 'Carlos G., Córdoba',
              role: 'Profesor de EF en Escuela Secundaria'
            }, {
              init: 'FR',
              quote: '"Antes tardaba 1 hora planificando la clase del día siguiente. Ahora son 5 minutos."',
              name: 'Fernanda R., Rosario',
              role: 'Profesora de EF Nivel Primario y Sec.'
            }].map((t, i) => <div key={i} className="bg-[#FDFBF7] rounded-2xl p-6 shadow-sm border border-gray-100 relative mt-4 md:mt-0" data-id="element-105">
                  <div className="absolute -top-5 left-6 w-10 h-10 bg-[#E84C3D] rounded-full flex items-center justify-center text-white font-bold text-sm border-4 border-white" data-id="element-106">
                    {t.init}
                  </div>
                  <p className="text-gray-700 font-medium italic mt-4 mb-4 text-sm leading-relaxed" data-id="element-107">
                    {t.quote}
                  </p>
                  <div data-id="element-108">
                    <p className="font-bold text-gray-900 text-sm" data-id="element-109">{t.name}</p>
                    <p className="text-xs text-gray-500 mt-0.5" data-id="element-110">{t.role}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* SECCIÓN 2 — DOLOR (MOVIDA AQUÍ) */}
        <section className="py-20 px-4 bg-white" data-id="element-111">
          <div className="max-w-4xl mx-auto" data-id="element-112">
            <h2 className="text-center text-3xl md:text-4xl font-black text-navy mb-4" data-id="element-113">
              👉 ¿Te reconocés en estas situaciones?
            </h2>
            <p className="text-center text-green-700 font-bold tracking-wide text-sm mb-10 uppercase" data-id="element-114">
              Si respondés sí a alguna — este pack es para vos
            </p>

            <div className="space-y-3 mb-16" data-id="element-115">
              {[{
              emoji: '😰',
              text: 'Llegás al patio sin saber exactamente qué juego o actividad dar hoy'
            }, {
              emoji: '⏱️',
              text: 'Tardás horas planificando lo que podrías resolver en minutos'
            }, {
              emoji: '🤷',
              text: 'Lluvia o poco espacio: te bloqueás cuando no tenés el gimnasio disponible'
            }, {
              emoji: '💸',
              text: 'Sin criterios claros: no sabés cómo evaluar de forma objetiva y profesional'
            }, {
              emoji: '😓',
              text: 'Tus alumnos están desmotivados y siempre terminan jugando a lo mismo'
            }, {
              emoji: '😩',
              text: 'El domingo a la noche seguís sin tener el lunes preparado'
            }].map((pain, i) => <div key={i} className="flex items-start gap-4 p-5 rounded-xl bg-[#FFF5F5]" data-id="element-116">
                  <span className="text-2xl shrink-0 mt-0.5" data-id="element-117">{pain.emoji}</span>
                  <p className="text-navy font-semibold md:text-lg leading-snug" data-id="element-118">
                    {pain.text}
                  </p>
                </div>)}
            </div>

            <div className="text-center" data-id="element-119">
              <h3 className="text-2xl md:text-3xl font-black italic text-navy mb-10" data-id="element-120">
                Y vos merecés mucho más que eso →
              </h3>
              <a href="#precio" className="inline-flex items-center justify-center gap-3 bg-orange hover:bg-orange-hover text-white font-bold text-lg py-4 px-8 rounded-full transition-all shadow-lg hover:-translate-y-1 w-full md:w-auto" data-id="element-121">
                👉 BASTA DE IMPROVISAR — QUIERO MI EF360
              </a>
            </div>
          </div>
        </section>

        {/* SECCIÓN 4 — LOS 12 TOMOS */}
        <section className="py-20 px-4 bg-white border-t border-gray-100" data-id="element-122">
          <div className="max-w-6xl mx-auto" data-id="element-123">
            <div className="text-center mb-16" data-id="element-124">
              <h2 className="text-4xl md:text-5xl font-black text-navy mb-4" data-id="element-125">
                📦 ¿Qué contiene el Pack EF360?
              </h2>
              <p className="text-xl text-gray-600 font-medium" data-id="element-126">
                Actividades graficadas · Por año escolar y nivel · Listo para
                usar mañana
              </p>
            </div>

            {/* Primaria */}
            <div className="mb-16" data-id="element-127">
              <div className="bg-navy text-white text-center py-4 rounded-xl font-black text-xl tracking-widest mb-8 shadow-md" data-id="element-128">
                PRIMARIA — TOMOS 1 AL 6
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-129">
                {[{
                n: 1,
                title: '1° Primaria',
                desc: 'Descubrimiento del cuerpo y el espacio. Juegos de esquema corporal, lateralidad y primeras nociones de movimiento.'
              }, {
                n: 2,
                title: '2° Primaria',
                desc: 'Habilidades con pelota y coordinación básica. Juegos de equipo para los primeros colectivos.'
              }, {
                n: 3,
                title: '3° Primaria',
                desc: 'Pre-deporte, juegos de invasión y liderazgo grupal. El primer acercamiento a lo táctico.'
              }, {
                n: 4,
                title: '4° Primaria',
                desc: 'Atletismo, juegos de red y condición física inicial. El cuerpo que empieza a rendir.'
              }, {
                n: 5,
                title: '5° Primaria',
                desc: 'Deportes colectivos, gimnasia básica y táctica grupal. El alumno que empieza a comprender el juego.'
              }, {
                n: 6,
                title: '6° Primaria',
                desc: 'Cierre del ciclo primario. Deportes reglamentados, autonomía y graduación. Incluye diploma de completación.'
              }].map(tomo => <div key={tomo.n} className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-[0_8px_30px_rgba(52,209,122,0.15)] transition-all group relative overflow-hidden" data-id="element-130">
                    <div className="absolute top-0 left-0 w-1 h-full bg-orange" data-id="element-131"></div>
                    <div className="inline-block bg-orange text-white text-xs font-bold px-3 py-1 rounded-full mb-4" data-id="element-132">
                      TOMO {tomo.n}
                    </div>
                    <h3 className="text-xl font-black text-navy mb-2 group-hover:text-electric transition-colors" data-id="element-133">
                      {tomo.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-134">
                      {tomo.desc}
                    </p>
                  </div>)}
              </div>
            </div>

            {/* Secundaria */}
            <div className="mb-16" data-id="element-135">
              <div className="bg-navy text-white text-center py-4 rounded-xl font-black text-xl tracking-widest mb-8 shadow-md" data-id="element-136">
                SECUNDARIA — TOMOS 7 AL 12
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-137">
                {[{
                n: 7,
                title: '1° Secundaria',
                desc: 'Condición física, deportes formales e introducción al entrenamiento.'
              }, {
                n: 8,
                title: '2° Secundaria',
                desc: 'Especialización deportiva, entrenamiento por objetivos y táctica intermedia.'
              }, {
                n: 9,
                title: '3° Secundaria',
                desc: 'Sistemas tácticos avanzados, alto rendimiento y proyecto deportivo personal.'
              }, {
                n: 10,
                title: '4° Secundaria',
                desc: 'Liderazgo deportivo, preparación física de competencia y análisis profesional.'
              }, {
                n: 11,
                title: '5° Secundaria',
                desc: 'Gran final, proyecto deportivo en acción y legado personal del alumno.'
              }, {
                n: 12,
                title: '6° Secundaria',
                desc: 'Cierre del ciclo completo. Graduación, legado y deportista para toda la vida. Incluye diploma final EF360.'
              }].map(tomo => <div key={tomo.n} className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-[0_8px_30px_rgba(52,209,122,0.15)] transition-all group relative overflow-hidden" data-id="element-138">
                    <div className="absolute top-0 left-0 w-1 h-full bg-electric" data-id="element-139"></div>
                    <div className="inline-block bg-orange text-white text-xs font-bold px-3 py-1 rounded-full mb-4" data-id="element-140">
                      TOMO {tomo.n}
                    </div>
                    <h3 className="text-xl font-black text-navy mb-2 group-hover:text-electric transition-colors" data-id="element-141">
                      {tomo.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-142">
                      {tomo.desc}
                    </p>
                  </div>)}
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-4" data-id="element-143">
              {[{
              icon: '✏️',
              text: 'Actividades graficadas en cada tomo'
            }, {
              icon: '⚡',
              text: 'Sistema "Abrí y Dictás"'
            }, {
              icon: '📋',
              text: 'Fichas listas para imprimir'
            }, {
              icon: '🇦🇷',
              text: 'Contenido 100% adaptado a Argentina'
            }].map((feat, i) => <div key={i} className="bg-green-50 text-navy font-bold px-5 py-3 rounded-full text-sm flex items-center gap-2 border border-green-100" data-id="element-144">
                  <span data-id="element-145">{feat.icon}</span> {feat.text}
                </div>)}
            </div>
          </div>
        </section>

        {/* SECCIÓN 5 — LOS 6 BONUS */}
        <section className="py-20 px-4 bg-[#FAF7F2]" data-id="element-146">
          <div className="max-w-6xl mx-auto" data-id="element-147">
            <div className="text-center mb-12" data-id="element-148">
              <h2 className="text-4xl md:text-5xl font-black text-navy mb-4 tracking-tight" data-id="element-149">
                🎁 6 Bonos Exclusivos
              </h2>
              <p className="text-lg md:text-xl text-gray-500 font-medium mb-8 max-w-xl mx-auto" data-id="element-150">
                Incluidos sin costo extra · Valor real del pack
              </p>
              <div className="inline-flex items-center gap-2 bg-orange text-white font-black px-6 py-3 rounded-full text-sm md:text-base shadow-lg animate-pulse" data-id="element-151">
                GRATIS POR EL DÍA DE HOY
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-152">
              {[{
              emoji: '📊',
              num: 1,
              title: 'Bonus 1 — La Planilla Maestra de Notas',
              desc: 'Detectá en segundos quién está en riesgo de desaprobar. Fórmulas automáticas para 200 alumnos. Sin cálculo manual.',
              color: '#2C5F7C',
              spine: '#1F4458'
            }, {
              emoji: '🚨',
              num: 2,
              title: 'Bonus 2 — Actividades de Emergencia',
              desc: '15 actividades listas para usar cuando todo falla. Sin patio, sin material, sin tiempo de preparación.',
              color: '#B8423C',
              spine: '#8C2F2A'
            }, {
              emoji: '🎒',
              num: 3,
              title: 'Bonus 3 — Clases Sin Presupuesto',
              desc: 'Cómo improvisar objetos y dar clases increíbles sin gastar un peso. 20 sustitutos de materiales listos.',
              color: '#D97B3A',
              spine: '#A85920'
            }, {
              emoji: '🧠',
              num: 4,
              title: 'Bonus 4 — Guía de Inclusión y Adaptaciones',
              desc: 'Cómo adaptar cualquier actividad para que NINGÚN alumno quede afuera. 5 perfiles · 5 protocolos.',
              color: '#6B4E8C',
              spine: '#4D3666'
            }, {
              emoji: '📅',
              num: 5,
              title: 'Bonus 5 — El Planificador Anual del Profe',
              desc: '52 semanas organizadas. Nunca más empezar el lunes sin saber qué dar.',
              color: '#5C8A4C',
              spine: '#3F6334'
            }, {
              emoji: '📋',
              num: 6,
              title: 'Bonus 6 — Pack de Plantillas de Seguimiento',
              desc: 'Detectá rápido quién está flojo, quién mejoró y quién necesita ayuda antes de desaprobar.',
              color: '#3D7A8C',
              spine: '#28586A'
            }].map((bonus, i) => <div key={i} className="bg-white rounded-3xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] hover:shadow-[0_12px_40px_rgba(0,0,0,0.12)] hover:-translate-y-2 transition-all duration-300 p-8 flex flex-col items-center text-center" data-id="element-153">
                  {/* Book mockup */}
                  <div className="mb-6 relative" style={{
                perspective: '1000px'
              }} data-id="element-154">
                    <div className="relative rounded-r-lg rounded-l-md overflow-hidden shadow-2xl" style={{
                  width: '170px',
                  height: '230px',
                  backgroundColor: bonus.color,
                  boxShadow: `0 20px 40px -10px ${bonus.color}66, 0 8px 16px rgba(0,0,0,0.15)`
                }} data-id="element-155">
                      {/* Spine on left */}
                      <div className="absolute top-0 left-0 h-full w-3" style={{
                    backgroundColor: bonus.spine
                  }} data-id="element-156"></div>
                      {/* Inner shadow line */}
                      <div className="absolute top-0 left-3 h-full w-px bg-black/10" data-id="element-157"></div>

                      {/* Book content */}
                      <div className="pl-7 pr-4 pt-6 pb-5 h-full flex flex-col justify-between text-white" data-id="element-158">
                        <div className="text-4xl" data-id="element-159">{bonus.emoji}</div>
                        <div className="text-left" data-id="element-160">
                          <div className="text-2xl font-black leading-tight mb-1" data-id="element-161">
                            Bonus {bonus.num}
                          </div>
                        </div>
                        <div data-id="element-162">
                          <div className="h-px bg-white/30 mb-2" data-id="element-163"></div>
                          <div className="text-[10px] font-bold tracking-widest opacity-80" data-id="element-164">
                            EF360™
                          </div>
                        </div>
                      </div>

                      {/* Subtle highlight */}
                      <div className="absolute top-0 left-3 right-0 h-1/3 bg-gradient-to-b from-white/10 to-transparent pointer-events-none" data-id="element-165"></div>
                    </div>
                  </div>

                  {/* Gratis badge */}
                  <div className="inline-flex items-center gap-1.5 bg-green-50 text-green-700 font-black px-4 py-1.5 rounded-full text-xs tracking-wide border border-green-200 mb-4" data-id="element-166">
                    GRATIS
                  </div>

                  {/* Title */}
                  <h3 className="text-xl md:text-2xl font-black text-navy mb-3 leading-tight" data-id="element-167">
                    {bonus.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-500 text-sm md:text-base leading-relaxed" data-id="element-168">
                    {bonus.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* SECCIÓN 6 — CONTADOR + PRECIO */}
        <section id="precio" className="py-24 px-4 bg-navy text-white relative" data-id="element-169">
          <div className="max-w-6xl mx-auto relative z-10" data-id="element-170">
            <div className="text-center mb-12" data-id="element-171">
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-black mb-4 tracking-tight" data-id="element-172">
                🏆 Oferta Especial de Lanzamiento
              </h2>

              <CountdownTimer data-id="element-173" />

              <div className="inline-flex items-center gap-2 bg-red-500/20 text-red-400 border border-red-500/30 px-4 py-2 rounded-full text-sm font-bold mt-2" data-id="element-174">
                <span className="w-2 h-2 rounded-full bg-red-500 animate-ping absolute" data-id="element-175"></span>
                <span className="w-2 h-2 rounded-full bg-red-500 relative" data-id="element-176"></span>
                El precio sube cuando termina el contador
              </div>
            </div>

            <PricingSelector data-id="element-177" />
          </div>
        </section>

        {/* SECCIÓN 10 — GARANTÍA (MOVIDA AQUÍ) */}
        <section className="py-16 px-4 bg-white text-center border-b border-gray-100" data-id="element-178">
          <div className="max-w-3xl mx-auto" data-id="element-179">
            <div className="text-6xl mb-6" data-id="element-180">🛡️</div>
            <h2 className="text-3xl md:text-4xl font-black text-navy mb-4" data-id="element-181">
              RECUPERÁ TU DINERO O TE LO DEVOLVEMOS
            </h2>

            <p className="text-lg text-gray-600 mb-8" data-id="element-182">
              7 días de garantía sin preguntas. Si no es lo que esperabas, te
              devolvemos el dinero. Escribinos al email y listo.
            </p>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-electric font-bold text-sm md:text-base mb-8" data-id="element-183">
              <span data-id="element-184">Sin preguntas.</span>
              <span className="hidden md:inline" data-id="element-185">•</span>
              <span data-id="element-186">Sin formularios.</span>
              <span className="hidden md:inline" data-id="element-187">•</span>
              <span data-id="element-188">Sin drama.</span>
            </div>
          </div>
        </section>

        {/* SECCIÓN 9 — TESTIMONIOS COMPLETOS */}
        <section className="py-20 px-4 bg-[#F5F5F5]" data-id="element-189">
          <div className="max-w-6xl mx-auto" data-id="element-190">
            <div className="text-center mb-16" data-id="element-191">
              <h2 className="text-3xl md:text-4xl font-black text-navy mb-4" data-id="element-192">
                Lo que dicen los profes de Educación Física...
              </h2>
              <div className="flex items-center justify-center gap-2 text-2xl font-black text-navy" data-id="element-193">
                4.9/5 <Star className="fill-orange text-orange" size={28} data-id="element-194" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-195">
              {[{
              init: 'MP',
              name: 'María P.',
              loc: 'Buenos Aires 🇦🇷',
              quote: '"Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más llego sin saber qué voy a dar."'
            }, {
              init: 'CG',
              name: 'Carlos G.',
              loc: 'Córdoba 🇦🇷',
              quote: '"Tres alumnos de 1° que estaban sin progreso mejoraron su coordinación en el primer mes usando el Tomo 1."'
            }, {
              init: 'FR',
              name: 'Fernanda R.',
              loc: 'Rosario 🇦🇷',
              quote: '"Antes tardaba 1 hora planificando la clase del día siguiente. Ahora son 5 minutos."'
            }, {
              init: 'SV',
              name: 'Sofía V.',
              loc: 'Mendoza 🇦🇷',
              quote: '"El Bonus de Seguimiento cambió cómo llevo mis notas. Ahora sé exactamente quién necesita ayuda antes de que sea tarde."'
            }, {
              init: 'DA',
              name: 'Diego A.',
              loc: 'Santa Fe 🇦🇷',
              quote: '"Con los 12 Tomos tengo actividades para todo el año. Mis clases nunca más quedaron cortas ni repetidas."'
            }, {
              init: 'CR',
              name: 'Carolina R.',
              loc: 'Tucumán 🇦🇷',
              quote: '"Los Bonos me resolvieron los días de lluvia y la falta de material. Llego al patio sin estrés y con todo listo."'
            }].map((t, i) => <div key={i} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col h-full border border-gray-100" data-id="element-196">
                  <div className="flex items-center gap-4 mb-4" data-id="element-197">
                    <div className="w-12 h-12 bg-orange rounded-full flex items-center justify-center text-white font-bold text-lg shrink-0" data-id="element-198">
                      {t.init}
                    </div>
                    <div data-id="element-199">
                      <p className="font-bold text-navy" data-id="element-200">{t.name}</p>
                      <p className="text-xs text-gray-500" data-id="element-201">{t.loc}</p>
                    </div>
                  </div>
                  <p className="text-gray-600 italic text-sm leading-relaxed flex-grow mb-4" data-id="element-202">
                    {t.quote}
                  </p>
                  <div className="flex gap-1" data-id="element-203">
                    {[...Array(5)].map((_, j) => <Star key={j} className="fill-orange text-orange" size={16} data-id="element-204" />)}
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* SOBRE EF360 */}
        <section className="py-20 px-4 bg-white border-t border-gray-100" data-id="element-205">
          <div className="max-w-3xl mx-auto text-center" data-id="element-206">
            <div className="text-5xl mb-6" data-id="element-207">⚽</div>
            <h2 className="text-3xl md:text-4xl font-black text-navy mb-6" data-id="element-208">
              Sobre Educación Física 360
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-209">
              Nacimos con una misión clara: devolverle el tiempo y la paz mental
              al docente de Educación Física argentino. Sabemos lo que es llegar
              al patio sin una estructura clara, planificar los domingos a la
              noche y pelear con el caos del grupo. EF360 es el sistema que nos
              hubiera gustado tener cuando empezamos: todo el año resuelto,
              graficado y adaptado a la realidad del aula argentina.
            </p>
          </div>
        </section>

        {/* SECCIÓN 11 — FAQ */}
        <section className="py-20 px-4 bg-[#F5F5F5]" data-id="element-210">
          <div className="max-w-3xl mx-auto" data-id="element-211">
            <h2 className="text-3xl md:text-4xl font-black text-navy text-center mb-12" data-id="element-212">
              Preguntas Frecuentes
            </h2>

            <div className="space-y-4" data-id="element-213">
              {[{
              q: '¿Cómo recibo el material?',
              a: 'Al completar el pago recibís un email con el acceso inmediato a todos los PDFs. Podés descargarlos en tu celular, tablet o computadora. Acceso de por vida.'
            }, {
              q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
              a: 'Sí para los dos. Si sos nuevo, el sistema te da estructura desde el primer día. Si tenés experiencia, te ahorra el tiempo de planificación semanal.'
            }, {
              q: '¿Los 6 Bonos están incluidos?',
              a: 'Sí. Los 6 Bonos estratégicos están incluidos en el Pack Completo, junto con los 12 Tomos. Todo por un solo pago.'
            }, {
              q: '¿Qué diferencia hay con otros materiales que ya existen?',
              a: 'EF360 es el único sistema diseñado específicamente para el docente argentino, con actividades graficadas, planificación anual integrada y recursos para los problemas reales del aula: SAF, ESI, EAI y seguimiento de alumnos.'
            }, {
              q: '¿Sirve para distintos niveles mezclados en el mismo grupo?',
              a: 'Sí. Cada tomo tiene guías de adaptación para grupos con distintos niveles de condición física o experiencia.'
            }, {
              q: '¿Qué pasa si no me sirve?',
              a: 'Tenés 7 días de garantía total. Si no te sirve te devolvemos el 100% sin preguntas.'
            }, {
              q: '¿Vale la pena si ya planifico bien mis clases?',
              a: 'Sí. Aunque ya planifiques bien, el Pack Completo te ahorra las horas de armado semanal: 12 Tomos con actividades graficadas por nivel y 6 Bonos estratégicos, listos para llevar al patio.'
            }, {
              q: '¿Puedo pagar con tarjeta de crédito?',
              a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y Mercado Pago.'
            }].map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-214" />)}
            </div>
          </div>
        </section>

        {/* SECCIÓN 12 — CTA FINAL */}
        <section className="py-24 px-4 bg-navy text-white text-center" data-id="element-215">
          <div className="max-w-4xl mx-auto" data-id="element-216">
            <div className="text-6xl mb-8" data-id="element-217">📚</div>
            <h2 className="text-3xl md:text-4xl font-black mb-6 leading-tight" data-id="element-218">
              ¿Listo/a para recuperar tu tiempo?
            </h2>
            <p className="text-xl md:text-2xl text-gray-400 italic mb-12 font-medium" data-id="element-219">
              "Porque preparar una buena clase no debería costarte todas las
              noches de la semana."
            </p>

            <a href="#precio" className="inline-flex items-center justify-center gap-3 bg-orange hover:bg-orange-hover text-white font-black text-xl md:text-3xl py-6 px-10 md:px-16 rounded-full transition-all shadow-[0_0_50px_rgba(255,107,53,0.5)] hover:shadow-[0_0_80px_rgba(255,107,53,0.7)] hover:-translate-y-2 w-full md:w-auto mb-8" data-id="element-220">
              💪 QUIERO MI EF360 AHORA
            </a>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 font-medium" data-id="element-221">
              <span className="flex items-center gap-2" data-id="element-222">
                <Shield size={18} data-id="element-223" /> Garantía 7 días
              </span>
              <span className="hidden md:inline" data-id="element-224">|</span>
              <span className="flex items-center gap-2" data-id="element-225">
                <Lock size={18} data-id="element-226" /> Pago seguro
              </span>
              <span className="hidden md:inline" data-id="element-227">|</span>
              <span className="flex items-center gap-2" data-id="element-228">
                <Zap size={18} data-id="element-229" /> Acceso inmediato
              </span>
            </div>
          </div>
        </section>

        {/* SECCIÓN 13 — FOOTER */}
        <footer className="bg-navy-dark text-white py-12 px-4 text-center" data-id="element-230">
          <div className="max-w-4xl mx-auto" data-id="element-231">
            <div className="font-black text-2xl tracking-tight flex items-center justify-center gap-2 mb-4" data-id="element-232">
              <span className="text-orange" data-id="element-233">🏃</span> EDUCACIÓN FÍSICA 360™
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-electric font-medium text-sm mb-12 mt-8" data-id="element-234">
              <span className="flex items-center gap-2" data-id="element-235">
                Términos y Condiciones
              </span>
              <span className="flex items-center gap-2" data-id="element-236">
                Política de Privacidad
              </span>
              <span className="flex items-center gap-2" data-id="element-237">Contacto</span>
            </div>

            <p className="text-gray-600 text-xs" data-id="element-238">
              © 2026 EDUCACIÓN FÍSICA 360™ — Todos los derechos reservados.
            </p>
          </div>
        </footer>
      </main>
    </div>;
}
function PricingSelector() {
  const pack = {
    id: 'completo',
    title: 'PACK COMPLETO',
    subtitle: '12 Tomos + 6 Bonos',
    price: '$19 USD',
    oldPrice: '$237 USD',
    priceValue: 19,
    cta: 'SÍ, QUIERO EL PACK COMPLETO',
    checkoutUrl: 'https://ef360.impultienda.ar/checkout'
  };
  const lineItems = [{
    label: '12 Tomos digitales completos',
    value: '$97'
  }, {
    label: '6 Bonos exclusivos',
    value: '$140'
  }];
  return <div className="relative bg-white rounded-3xl border-2 border-orange/50 shadow-2xl max-w-2xl mx-auto px-6 py-10 md:px-10 md:pt-12 md:pb-10" data-id="element-239">
      {/* Badge sitting on the top border */}
      <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-240">
        <span className="inline-block bg-orange text-white font-black text-xs md:text-sm tracking-wide px-6 py-2 rounded-full shadow-md whitespace-nowrap" data-id="element-241">
          CONTENIDO DEL PACK:
        </span>
      </div>

      {/* Line items */}
      <div className="mt-4" data-id="element-242">
        {lineItems.map(item => <div key={item.label} className="flex items-center justify-between py-4 border-b border-gray-200" data-id="element-243">
            <span className="text-navy font-bold text-sm md:text-lg" data-id="element-244">
              {item.label}
            </span>
            <span className="text-orange font-black line-through text-sm md:text-lg shrink-0 pl-3" data-id="element-245">
              {item.value}
            </span>
          </div>)}

        {/* Total */}
        <div className="flex items-center justify-between py-4" data-id="element-246">
          <span className="text-navy font-black text-base md:text-lg tracking-wide" data-id="element-247">
            VALOR TOTAL:
          </span>
          <span className="text-orange font-black line-through text-base md:text-xl shrink-0 pl-3" data-id="element-248">
            {pack.oldPrice}
          </span>
        </div>
      </div>

      {/* Big price */}
      <div className="text-center mt-4 mb-2" data-id="element-249">
        <div className="flex items-center justify-center gap-2" data-id="element-250">
          <span className="text-4xl md:text-5xl" data-id="element-251">🏆</span>
          <span className="text-5xl md:text-7xl font-black text-orange leading-none" data-id="element-252">
            {pack.price}
          </span>
        </div>
        <p className="text-orange font-black line-through text-lg md:text-xl mt-2" data-id="element-253">
          {pack.oldPrice}
        </p>
      </div>

      {/* Currency note */}
      <p className="text-center text-gray-600 text-sm md:text-base max-w-md mx-auto leading-relaxed mt-4 mb-6" data-id="element-254">
        💳 Vas a pagar en la moneda de tu país, con conversión automática al
        tipo de cambio del día.
      </p>

      {/* Big CTA */}
      <a href={pack.checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={() => {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        try {
          ;
          (window as any).fbq('track', 'InitiateCheckout', {
            content_name: pack.title,
            content_ids: [pack.id],
            value: pack.priceValue,
            currency: 'USD'
          });
        } catch (e) {
          // silent
        }
      }
    }} className="w-full py-5 md:py-6 rounded-full bg-orange hover:bg-orange-hover text-white font-black text-base md:text-xl shadow-[0_10px_30px_rgba(255,107,53,0.4)] hover:shadow-[0_15px_40px_rgba(255,107,53,0.5)] transition-all hover:-translate-y-1 flex items-center justify-center text-center px-4" data-id="element-255">
        {pack.cta}
      </a>

      {/* Trust line */}
      <p className="text-center text-navy font-bold text-sm md:text-base mt-6 leading-relaxed" data-id="element-256">
        Descarga inmediata · Pago único · Acceso de por vida · 7 días de
        garantía
      </p>
    </div>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-257">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-258">
        <span className="font-bold text-navy pr-4" data-id="element-259">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="text-orange shrink-0" data-id="element-260">
          <ChevronDown size={20} data-id="element-261" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-262">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-263">
            <div className="px-6 pb-5 text-gray-600 text-sm leading-relaxed border-t border-gray-50 pt-4" data-id="element-264">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}